import { render, staticRenderFns } from "./BaseStyle.vue?vue&type=template&id=ab88ea92&scoped=true"
import script from "./BaseStyle.vue?vue&type=script&lang=js"
export * from "./BaseStyle.vue?vue&type=script&lang=js"
import style0 from "./BaseStyle.vue?vue&type=style&index=0&id=ab88ea92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88ea92",
  null
  
)

export default component.exports